export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

function openModal(modalProps) {
  return {
    type: OPEN_MODAL,
    modalProps
  }
}

function closeModal() {
  return {
    type: CLOSE_MODAL
  }
}

export default function modalReducer(state, action = {}) {
  const currentState = state === undefined ? { open: false } : state

  switch (action.type) {
    case OPEN_MODAL: {
      const defaults = {
        confirmButton: 'Confirm',
        cancelButton: 'Cancel'
      }
      return Object.assign(
        defaults,
        { open: true, className: 'universal-modal' },
        action.modalProps
      )
    }
    case CLOSE_MODAL:
      return { open: false }
    default:
      return currentState
  }
}

export const modalActions = {
  openModal,
  closeModal
}
